import PropTypes from 'prop-types';
import { donationTypeLabels, donationBillingIntervalLabels } from '../../core/constants';

const DonationType = ({ type, paymentInfo, billingInterval }) => {
  const intervalLabel = paymentInfo.subscription
    ? ` ${donationBillingIntervalLabels[billingInterval] || donationBillingIntervalLabels.month}`
    : '';
  return paymentInfo.subscription ? (
    <p>
      {donationTypeLabels[type]}
      {intervalLabel} - <span className="uppercase">{paymentInfo.subscription.status}</span>
    </p>
  ) : (
    <span>{donationTypeLabels[type]}</span>
  );
};

DonationType.propTypes = {
  type: PropTypes.string.isRequired,
  paymentInfo: PropTypes.shape({ subscription: PropTypes.shape({ status: PropTypes.string.isRequired }) }).isRequired,
  billingInterval: PropTypes.string,
};

export default DonationType;
